import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

// Dashboard stats
export async function fetchDashboardStats(): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/dashboard`);
    return response.data;
}

// Products API
export async function fetchProducts(): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/products`);
    return response.data;
}

export async function createProduct(data: {
    name: string;
    description: string;
    version: string;
    featuresTemplate: Record<string, any>;
}): Promise<any> {
    const response = await axios.post(`${API_BASE_URL}/admin/products`, data);
    return response.data;
}

// Licenses API
export async function fetchLicenses(params?: {
    page?: number;
    limit?: number;
    status?: string;
    productId?: string;
    search?: string;
}): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/licenses`, { params });
    return response.data;
}

export async function createLicense(data: {
    licenseKey?: string;
    productId: string;
    customerId?: string;
    serverLimit?: number;
    expiresAt?: number;
    gracePeriodDays?: number;
    features?: Record<string, any>;
}): Promise<any> {
    const response = await axios.post(`${API_BASE_URL}/admin/licenses`, data);
    return response.data;
}

// Servers API
export async function fetchServers(): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/servers`);
    return response.data;
}

// Customers API
export async function fetchCustomers(): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/customers`);
    return response.data;
}

// Logs API
export async function fetchLogs(): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/admin/logs`);
    return response.data;
}